var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 144,
    viewBox: "0 0 204 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8232 92.0506C64.2048 107.628 50.091 121.052 39.0174 118.78C18.8751 114.648 12.7652 80.1178 17.5383 61.5026C22.6454 41.5852 35.6389 30 56.2006 30C56.2007 30 56.2007 30 56.2007 30H148.799H153.572V30.2192C171.383 31.9001 182.762 43.173 187.462 61.5026C192.235 80.1178 186.125 114.648 165.983 118.78C154.909 121.052 140.289 107.628 130.26 92.0506H73.8232Z",
    fill: "#00ABC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0174 118.78L39.6203 115.841L39.6203 115.841L39.0174 118.78ZM73.8232 92.0506V89.0506H72.1498L71.2706 90.4745L73.8232 92.0506ZM17.5383 61.5026L14.6323 60.7575L17.5383 61.5026ZM153.572 30H156.572V27H153.572V30ZM153.572 30.2192H150.572V32.9494L153.291 33.206L153.572 30.2192ZM187.462 61.5026L184.556 62.2477L187.462 61.5026ZM165.983 118.78L165.38 115.841V115.841L165.983 118.78ZM130.26 92.0506L132.782 90.4266L131.896 89.0506H130.26V92.0506ZM38.4146 121.719C45.3218 123.136 52.5577 119.608 58.8693 114.428C65.307 109.144 71.4447 101.613 76.3758 93.6267L71.2706 90.4745C66.5833 98.0659 60.8549 105.036 55.0627 109.79C49.1444 114.648 43.7866 116.696 39.6203 115.841L38.4146 121.719ZM14.6323 60.7575C12.094 70.657 12.4754 84.5026 16.0615 96.436C19.6037 108.223 26.6697 119.31 38.4146 121.719L39.6203 115.841C31.2229 114.119 25.1627 105.874 21.8077 94.7093C18.4965 83.6907 18.2095 70.9634 20.4443 62.2477L14.6323 60.7575ZM56.2006 27C45.3305 27 36.2295 30.0752 29.1523 35.9785C22.0989 41.862 17.3013 50.3485 14.6323 60.7575L20.4443 62.2477C22.8824 52.7393 27.1351 45.4745 32.9956 40.586C38.8324 35.7174 46.5089 33 56.2006 33V27ZM56.2007 27H56.2007H56.2007C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27H56.2007C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27H56.2007C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27H56.2007H56.2007C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27H56.2007H56.2007C56.2007 27 56.2007 27 56.2007 27C56.2007 27 56.2007 27 56.2007 27H56.2006C56.2006 27 56.2006 27 56.2006 27H56.2006C56.2006 27 56.2006 27 56.2006 27H56.2006C56.2006 27 56.2006 27 56.2006 27C56.2006 27 56.2006 27 56.2006 27H56.2006H56.2006H56.2006V33H56.2006H56.2006H56.2006C56.2006 33 56.2006 33 56.2006 33C56.2006 33 56.2006 33 56.2006 33H56.2006C56.2006 33 56.2006 33 56.2006 33H56.2006C56.2006 33 56.2006 33 56.2006 33H56.2007C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33H56.2007H56.2007C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33H56.2007H56.2007C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33H56.2007C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33H56.2007C56.2007 33 56.2007 33 56.2007 33C56.2007 33 56.2007 33 56.2007 33H56.2007H56.2007V27ZM56.2007 33H148.799V27H56.2007V33ZM148.799 33H153.572V27H148.799V33ZM150.572 30V30.2192H156.572V30H150.572ZM153.291 33.206C161.598 33.99 168.252 36.9839 173.379 41.8034C178.53 46.6461 182.312 53.4964 184.556 62.2477L190.368 60.7575C187.912 51.1792 183.654 43.2283 177.488 37.4319C171.298 31.6123 163.357 28.1293 153.854 27.2325L153.291 33.206ZM184.556 62.2477C186.79 70.9634 186.503 83.6907 183.192 94.7093C179.837 105.874 173.777 114.119 165.38 115.841L166.585 121.719C178.33 119.31 185.396 108.223 188.938 96.436C192.525 84.5026 192.906 70.657 190.368 60.7575L184.556 62.2477ZM165.38 115.841C161.199 116.699 155.71 114.636 149.6 109.763C143.625 104.998 137.67 98.0189 132.782 90.4266L127.737 93.6746C132.878 101.66 139.247 109.181 145.859 114.454C152.335 119.619 159.692 123.133 166.585 121.719L165.38 115.841ZM130.26 89.0506H73.8232V95.0506H130.26V89.0506Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.2227,
    y: 44.1836,
    width: 5.72775,
    height: 30.548,
    rx: 2.86387,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.335,
    y: 61.8438,
    width: 5.72775,
    height: 30.548,
    rx: 2.86387,
    transform: "rotate(-90 30.335 61.8438)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2324,
    y: 70.9131,
    width: 5.72775,
    height: 19.0925,
    rx: 2.86387,
    transform: "rotate(-90 72.2324 70.9131)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7783,
    y: 50.4102,
    width: 7.637,
    height: 33.4119,
    rx: 3.8185,
    transform: "rotate(-90 80.7783 50.4102)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108.508,
    y: 70.9131,
    width: 5.72775,
    height: 19.0925,
    rx: 2.86387,
    transform: "rotate(-90 108.508 70.9131)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.482,
    cy: 48.0021,
    r: 3.8185,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.938,
    cy: 57.548,
    r: 3.8185,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.482,
    cy: 67.0939,
    r: 3.8185,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.027,
    cy: 57.548,
    r: 3.8185,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameHover);
export default __webpack_public_path__ + "static/media/gameHover.aed4f40eb454fce12c5672398dddec82.svg";
export { ForwardRef as ReactComponent };